import { State } from "../../../vendor_core/core/src/states/State";
import BURFeatureModel from "../models/BURFeatureModel";
import BURReelsModel from "../models/BURReelsModel";

/**
 * Tweaks the spin data to match the pre-feature state because
 * the init response has the post-feature updated data
 */
export default class BURRecoverFreeSpinsState extends State {
    public async enter() {
        super.enter();

        BURReelsModel.pre_trigger_combo.forEach((color) => {
            BURReelsModel.energy_meters.onRecover(
                color,
                BURReelsModel.pre_trigger_meters_progress![color.toLowerCase()]
                    .coins
            );
        });

        this.exit();
    }
}
